import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import TGApi from 'lib/webapp-api';
import useBoundStore from 'store';

const NotificationScreenWrapper: React.FC = () => {
  const isAuth = useBoundStore.getState().authToken;

  useEffect(() => {
    TGApi.expand();
    if (!isAuth) {
      useBoundStore.getState().openAuthBottomSheet();
    }
  }, []);

  return <Outlet />;
};

export default NotificationScreenWrapper;
